import { css, CSSResultGroup, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("video-player")
export class VideoPlayer extends LitElement {
	static readonly styles: CSSResultGroup = css`
        :host {
            display: block;
            width: 100%;
            height: 100%;
        }

        .video-container {
            padding-bottom: 56.25%; /* 16:9 aspect ratio */
            height: 100%;
			width: 100%;
            border-radius: var(--border-radius, 12px);
            box-shadow: var(--shadow-default);
        }

        iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
        }
    `;

	@property({ type: String })
	videoLink: string = "";



	render() {

		return html`
            <div class="video-container">
                <iframe 
                    src="${this.videoLink}"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen>
                </iframe>
            </div>
        `;
	}
}

export default VideoPlayer;
